export const PROFILESTATUS_ARRAY = [
  ["Aktywne", "active"],
  ["Dodaj ofertę", "add_offer"],
  ["Nie aktywne", "deactivated"],
]

export const PROFILE_FEATURE_FLAGS_ARRAY: ReadonlyArray<readonly [string, string, string]> = [
  ["Statystyki oferty", "analytics", "Dostęp do liczników zdarzeń i statystyk ofert profilu."],
  ["AI chat", "ai_chat", "Funkcja czatu AI dostępna w widoku oferty na storefronie."],
]

export const PROFILEINDUSTRIE_ARRAY = [
  ["Transport", "transport"],
  ["Spedycja", "spedycja"],
  ["Logistyka", "logistyka"],
  ["Agencja pracy", "agency"],
  ["Inne", "other"],
]

export const TRUCKBRANDS_ARRAY = [
  ["Volvo", "Volvo"],
  ["Scania", "Scania"],
  ["Mercedes-Benz", "Mercedes-Benz"],
  ["MAN", "MAN"],
  ["DAF", "DAF"],
  ["Iveco", "Iveco"],
]

export const PROFILESIZE_ARRAY = [
  ["1-5", "1#5"],
  ["5-10", "5#10"],
  ["10-25", "10#25"],
  ["25-50", "25#50"],
  ["50-100", "50#100"],
  ["100-250", "100#250"],
  ["250-500", "250#500"],
  ["+500", "#500"],
]

export const OTHERPOSITIONS_ARRAY = [
  ["Spedytor", "spedytor"],
  ["Dyspozytor", "dyspozytor"],
  ["Planista", "planista"],
  ["Handlowiec", "handlowiec"],
  ["Opiekun floty", "opiekunfloty"],
  ["Referent FK", "referentfk"],
  ["Inny", "other"],
]
